import React from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-column">
          <h4>Get Help</h4>
          <Link to="/faq">FAQ</Link>
          {/* <Link to="/support">Support</Link> */}
          <Link to="/contact">Contact Us</Link>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <Link to="/about">About Us</Link>
          <Link to="/services">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>

        {/* <div className="footer-column">
          <h4>Affiliate</h4>
          <Link to="/affiliate">Affiliate Program</Link>
          <Link to="/partner">Partner Login</Link>
          <Link to="/referral">Referral Guide</Link>
        </div> */}
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Vortex Network. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
